import type { RouteObject } from 'react-router';
import { UnlockPage } from '~/pages/unlock/UnlockPage';

/**
 * SMS door-unlock link route.
 *
 * Sits OUTSIDE the `MissingParamsGuard` layout that wraps every other route. That guard
 * hard-errors without `club-id` and `tenant-handle` query params, and this page has neither
 * by design — the whole point is that the token is the only thing in the URL. The exchange
 * supplies both, which is why the page must be allowed to render first.
 *
 * `/unlock` without a token is a real state, not a 404: the page moves the token into
 * sessionStorage and scrubs the URL, so this is what the address bar says for the rest of the
 * session, and a refresh lands here.
 *
 * Unlinked — nothing in the app navigates here.
 */
export const unlockRoutes: RouteObject[] = [
  { path: '/unlock/:token', element: <UnlockPage /> },
  { path: '/unlock', element: <UnlockPage /> },
];
